<app-header [connected]="connected" class="app-header"></app-header>

<div class="wrapper">
  <app-sidebar class="aside" *ngIf="connected"></app-sidebar>
  <mat-sidenav-container [ngClass]="connected ? 'main main-bis' : 'main'">
      <mat-sidenav-content class="page-wrapper">
              <div class="page-content">
                      <router-outlet></router-outlet>
              </div>
      </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<hv-footer
  class="app-footer"
  wordImpressum=""
  wordJuridique=""
  wordDonnees=""
  wordConseil=""
  [version]="version"
  >
</hv-footer>

<hv-banniere></hv-banniere>